import { useEffect } from "react";
import { GlassContainer } from "../components/Containers";
import { Typography } from "antd";
import {
  DownloadOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import Buttons from "../components/Buttons";

const { Title, Text } = Typography;

export default function ProjectMisToDo(args) {
  useEffect(() => {
    args.setCurrent("projects");
    document.title = "Mis To Do | Zenofy";
  }, [args]);
  console.log(args.setCurrent);
  return (
    <div style={{ marginTop: "4rem",display:"flex",flexDirection:"column",alignItems:"center" }}>
      <GlassContainer
        width="95vw"
        height="60rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <div
            style={{
              width: "100%",
              height: "100%",

              display: "flex",
              flexDirection: args.device === "phone" ? "column" : "row",
              alignItems: "center",
              justifyContent: "center",
              padding:
                args.device === "phone"
                  ? "calc(1rem + 3vw) 0"
                  : "0 calc(1rem + 3vw)",

              gap: "calc(4rem + 4vw)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: args.device === "phone" ? "100%" : "30%",
                height: args.device === "phone" ? "30%" : "100%",
              }}
            >
              <Typography.Title style={{color:"white",fontSize:"7rem",margin:"0",textAlign:"center"}}>Mis To Do</Typography.Title>
              <Typography.Title style={{color:"white",fontSize:"2rem",marginTop:"0"}}>[Alpha]</Typography.Title>
            </div>
            <div
              style={{
                width: args.device === "phone" ? "100%" : "50%",
                height: args.device === "phone" ? "50%" : "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Title
                style={{
                  marginBottom: "1rem",
                  color: "var(--light)",
                  fontSize:
                    args.device === "pc"
                      ? "calc(10px + 4vw)"
                      : "calc(1rem + 9vw)",
                }}
              >
                Hayatını istediğin gibi düzenle, planla ve hatırla.
              </Title>
              <Text
                style={{
                  marginBottom: "6rem",
                  color: "var(--light)",
                  fontSize:
                    args.device === "pc"
                      ? "calc(1rem + 1vw)"
                      : "calc(1rem + 1vw)",
                }}
              >
                Mis To Do ile haftalık programını oluştur ve beklenmeyen şeylere karşı hazırlıklı ol!
              </Text>
              <Buttons
                buttonsPrimary={["İndir"]}
                buttons={["Forum"]}
                href={["/forum/mistodo"]}
                hrefPrimary={["https://api.zenofy.tr/mis_to_do/MisToDo-Alpha-v0.6.2.apk"]}
                tooltipPrimary={[<Text>Hemen İndir!</Text>]}
                iconsPrimary={[<DownloadOutlined />]}
                icons={[<TeamOutlined />]}
                iconPlacement="end"
                device={args.device}
              ></Buttons>
            </div>
          </div>
        }
      ></GlassContainer>
      <Typography.Title style={{textAlign:"center",color:"white",fontWeight:"bold",fontSize:"4rem"}}>Ekran Fotoğrafları [Alpha]</Typography.Title>
      <Typography.Title style={{textAlign:"center",color:"white",fontWeight:"bold",fontSize:"2rem"}}>Mobil Sürümü</Typography.Title>
      <div style={{display:"flex",flexDirection:"row",margin:"1rem",maxWidth: args.device !== "phone" ? "60%" : "150%"}} >
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem",width:args.device === "phone" ? "400%" : "100%"}}>
             <GlassContainer height="150%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/1.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem",width:args.device === "phone" ? "400%" : "100%"}}>
             <GlassContainer height="150%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/2.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem",width:args.device === "phone" ? "400%" : "100%"}}>
             <GlassContainer height="150%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/3.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
      </div>
        
      <div style={{display:"flex",flexDirection:"row",margin:"1rem", maxWidth: args.device !== "phone" ? "60%" : "150%"}} >
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/_1.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/_2.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/_3.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"row",margin:"1rem", maxWidth: args.device !== "phone" ? "60%" : "150%"}} >
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/4.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/0.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/_5.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"row",margin:"1rem", maxWidth: args.device !== "phone" ? "60%" : "150%"}} >
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/7.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/8.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/9.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"row",margin:"1rem", maxWidth: args.device !== "phone" ? "60%" : "150%"}} >
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/_4.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/10.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/11.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"row",margin:"1rem", maxWidth: args.device !== "phone" ? "60%" : "150%"}} >
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/5.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/6.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"1rem"}}>
             <GlassContainer height="100%" bigger_height="100%" width="100%" inside={<img src="https://api.zenofy.tr/mis_to_do/12.jpeg" alt="mis_to_do ss" style={{maxWidth:"90%",paddingBottom:"5%",paddingTop:"5%"}}/>}/>
        </div>
      </div>

    </div>
  );
}

/*<GlassContainer
              width={args.device === "phone" ? "90vw" : "60vw"}
              height="40rem"
              bigger_height="50rem"
              device={args.device}
              inside={
                <div
                  style={{
                    padding: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Carousel
                    style={{
                      width: "80vw",
                      height: args.device === "phone" ? "40rem" : "50rem",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                    autoplay={{ dotDuration: true }}
                    autoplaySpeed={5000}
                    draggable
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          1
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          2
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          3
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          4
                        </div>
                      </Title>
                    </div>
                  </Carousel>
                </div>
              }
            ></GlassContainer> */
